<button id="back" class="flex h-full w-fit gap-2 items-center cursor-pointer hover:underline hover:decoration-afcu-navy-800 hover:bg-afcu-navy-50 pr-2 hover:text-afcu-navy-800" autofocus tabindex="0" (click)="goTo()">
  <img src="/icons/arrow/back-blue.svg">
  <div class="flex text-[#00538B] font-semibold text-sm capitalize">{{getText().back}}</div>
</button>

    